import * as PIXI from "pixi.js";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class InfoSnackBar extends PIXI.Container {

    private static readonly ANIMATION_CONFIG = {
        NAME: "snackBar",
        STATES: {
            SHOW: "animation",
        },
        SLOT_CONTAINERS: {
            MAIN: "main_slot_container",
        },
    };

    private animation: CustomSpineAnimation;
    private text: PIXI.Text;
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private readonly MESSAGE_STYLE = {
        fontSize: 25,
        fontFamily: "RobotoRegular",
        dropShadow: true,
        dropShadowAngle: 1.4,
        dropShadowBlur: 3,
        dropShadowDistance: 3,
        fill: "#fcdb48",
        fontWeight: "bolder",
    };

    constructor() {
        super();
        this.animation = new CustomSpineAnimation(InfoSnackBar.ANIMATION_CONFIG.NAME);
        this.text = new PIXI.Text("", this.MESSAGE_STYLE);
        this.text.anchor = this.DEFAULT_ANCHOR_POINT;
        (window as any).text = this.text;
        this.animation.getSlotContainer(InfoSnackBar.ANIMATION_CONFIG.SLOT_CONTAINERS.MAIN, true).addChild(this.text);
        this.addChild(this.animation);
    }

    public show(message: string, position: PIXI.Point): void {
        this.animation.position = position;
        this.text.text = message;
        this.animation.play(InfoSnackBar.ANIMATION_CONFIG.STATES.SHOW);
    }
}



// WEBPACK FOOTER //
// ./src/app/InfoSnackBar.ts